/*
  Aurev PDP v2 — behaviour for the aurev-pdp2-* sections.
  Several sections include this file, so it guards against running twice.
*/
(function () {
  if (window.AurevPDP2) return;

  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var DAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  var MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

  /* ---------- Cart ---------- */
  // Posts to the AJAX cart, then fires Impulse's own ajaxProduct:added event on
  // the form so the theme rebuilds and opens its cart drawer.
  function addToCart(form, button) {
    var err = form.querySelector('[data-mv-error]');
    if (err) { err.hidden = true; err.textContent = ''; }
    if (button) { button.disabled = true; button.classList.add('is-loading'); }

    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' },
      body: new FormData(form)
    })
      .then(function (res) {
        return res.json().then(function (data) {
          if (!res.ok || data.status) {
            throw new Error(data.description || data.message || 'Sorry, this item could not be added to your cart.');
          }
          var cartType = window.theme && theme.settings && theme.settings.cartType;
          if (cartType === 'page') {
            window.location.href = root + 'cart';
            return data;
          }
          form.dispatchEvent(new CustomEvent('ajaxProduct:added', { bubbles: true, detail: { product: data, addToCartBtn: button } }));
          return data;
        });
      })
      .catch(function (e) {
        if (err) { err.textContent = e.message; err.hidden = false; }
        form.dispatchEvent(new CustomEvent('ajaxProduct:error', { bubbles: true, detail: { errorMessage: e.message } }));
      })
      .finally(function () {
        if (button) {
          button.classList.remove('is-loading');
          button.disabled = button.hasAttribute('data-unavailable');
        }
      });
  }

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (ch) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch];
    });
  }

  /* ---------- Countdown ---------- */
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function initCountdowns(scope) {
    scope.querySelectorAll('[data-mv-countdown]').forEach(function (el) {
      if (el.dataset.ready) return;
      el.dataset.ready = '1';
      var raw = el.dataset.end || '';
      // "today" = count down to the visitor's local midnight, restarting daily.
      // Test mode only: it runs in the theme editor / unpublished preview and hides
      // itself on a published theme, where a real end date must be used.
      var daily = /^today/i.test(raw);
      var end;
      if (daily) {
        var preview = false;
        try { preview = JSON.parse(el.closest('[data-mv]').querySelector('[data-mv-json]').textContent).preview === true; } catch (e) { /* not preview */ }
        if (!preview) { el.hidden = true; return; }
        var midnight = new Date();
        midnight.setHours(23, 59, 59, 999);
        end = midnight.getTime();
      } else {
        end = Date.parse(raw);
      }
      if (isNaN(end)) { el.hidden = true; return; }
      var parts = {};
      el.querySelectorAll('[data-cd]').forEach(function (p) { parts[p.dataset.cd] = p; });
      var timer;
      function tick() {
        var diff = end - Date.now();
        if (diff <= 0 && daily) { end += 86400000; diff = end - Date.now(); }
        if (diff <= 0) { el.hidden = true; clearInterval(timer); return; }
        var s = Math.floor(diff / 1000);
        if (parts.d) parts.d.textContent = pad(Math.floor(s / 86400));
        if (parts.h) parts.h.textContent = pad(Math.floor((s % 86400) / 3600));
        if (parts.m) parts.m.textContent = pad(Math.floor((s % 3600) / 60));
        if (parts.s) parts.s.textContent = pad(s % 60);
      }
      tick();
      timer = setInterval(tick, 1000);
    });
  }

  /* ---------- Ships-by date (UK time, skips weekends) ---------- */
  function initShipBy(scope) {
    scope.querySelectorAll('[data-mv-ship]').forEach(function (el) {
      if (el.dataset.ready) return;
      el.dataset.ready = '1';
      var out = el.querySelector('[data-mv-ship-date]');
      if (!out) return;
      var days = parseInt(el.dataset.days, 10) || 1;
      var y, m, d;
      try {
        new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/London', year: 'numeric', month: 'numeric', day: 'numeric' })
          .formatToParts(new Date())
          .forEach(function (p) {
            if (p.type === 'year') y = +p.value;
            if (p.type === 'month') m = +p.value;
            if (p.type === 'day') d = +p.value;
          });
      } catch (e) {
        var now = new Date();
        y = now.getFullYear(); m = now.getMonth() + 1; d = now.getDate();
      }
      var date = new Date(Date.UTC(y, m - 1, d, 12));
      var added = 0;
      while (added < days) {
        date.setUTCDate(date.getUTCDate() + 1);
        var wd = date.getUTCDay();
        if (wd !== 0 && wd !== 6) added++;
      }
      out.textContent = DAYS[date.getUTCDay()] + ' ' + date.getUTCDate() + ' ' + MONTHS[date.getUTCMonth()];
    });
  }

  /* ---------- Main product section ---------- */
  function initMain(section) {
    if (section.dataset.mvReady) return;
    section.dataset.mvReady = '1';

    var data = { variants: [], preview: false };
    try { data = JSON.parse(section.querySelector('[data-mv-json]').textContent); } catch (e) { /* keep defaults */ }
    var variants = data.variants || [];
    var desktop = window.matchMedia('(min-width: 990px)');

    /* Gallery */
    var slider = section.querySelector('[data-mv-slider]');
    var slides = slider ? Array.prototype.slice.call(slider.querySelectorAll('[data-mv-slide]')) : [];
    var dots = section.querySelectorAll('[data-mv-dot]');

    function currentIndex() {
      if (!slider || !slider.clientWidth) return 0;
      return Math.round(slider.scrollLeft / slider.clientWidth);
    }
    function goTo(i) {
      if (!slider || !slides.length || desktop.matches) return;
      i = (i + slides.length) % slides.length;
      slider.scrollTo({ left: slides[i].offsetLeft, behavior: 'smooth' });
    }
    if (slider) {
      var scrollTimer;
      slider.addEventListener('scroll', function () {
        clearTimeout(scrollTimer);
        scrollTimer = setTimeout(function () {
          var i = currentIndex();
          dots.forEach(function (dot, n) { dot.classList.toggle('is-active', n === i); });
        }, 60);
      }, { passive: true });
      slider.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); goTo(currentIndex() + 1); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(currentIndex() - 1); }
      });
    }
    var prev = section.querySelector('[data-mv-prev]');
    var next = section.querySelector('[data-mv-next]');
    if (prev) prev.addEventListener('click', function () { goTo(currentIndex() - 1); });
    if (next) next.addEventListener('click', function () { goTo(currentIndex() + 1); });
    dots.forEach(function (dot) { dot.addEventListener('click', function () { goTo(+dot.dataset.mvDot); }); });

    /* Variants */
    var optionSets = Array.prototype.slice.call(section.querySelectorAll('[data-mv-option]'));
    var form = section.querySelector('[data-mv-form]');
    var atc = section.querySelector('[data-mv-atc]');
    var atcLabel = section.querySelector('[data-mv-atc-label]');
    var stock = section.querySelector('[data-mv-stock]');
    var sticky = section.querySelector('[data-mv-sticky]');
    var stickySelect = sticky ? sticky.querySelector('[data-mv-sticky-select]') : null;

    function selected() {
      return optionSets.map(function (fs) {
        var c = fs.querySelector('input:checked');
        return c ? c.value : null;
      });
    }
    function matchVariant(sel) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i], ok = true;
        for (var j = 0; j < sel.length; j++) { if (v.options[j] !== sel[j]) { ok = false; break; } }
        if (ok) return v;
      }
      return null;
    }
    function refreshAvailability(sel) {
      optionSets.forEach(function (fs, i) {
        fs.querySelectorAll('.mv-val').forEach(function (wrap) {
          var test = sel.slice();
          test[i] = wrap.querySelector('input').value;
          var v = matchVariant(test);
          wrap.classList.toggle('is-unavailable', !v || !v.available);
        });
      });
    }
    function savePct(v) {
      return v && v.compare > v.price ? Math.round((v.compare - v.price) * 100 / v.compare) : 0;
    }
    function updateStock(v) {
      if (!stock) return;
      var threshold = parseInt(stock.dataset.threshold, 10) || 10;
      var show = false, text = '', pct = 0;
      if (v && v.tracked && v.qty > 0 && v.qty <= threshold) {
        show = true;
        text = (stock.dataset.template || '').replace('[qty]', v.qty);
        pct = Math.max(8, Math.round(v.qty * 100 / threshold));
      } else if (data.preview && v && v.available) {
        show = true;
        text = stock.dataset.previewText || '';
        pct = 30;
      }
      stock.hidden = !show;
      var t = stock.querySelector('[data-mv-stock-text]');
      var f = stock.querySelector('[data-mv-stock-fill]');
      if (t) t.textContent = text;
      if (f) f.style.width = pct + '%';
    }
    function update(fromUser) {
      var sel = selected();
      var v = matchVariant(sel);
      refreshAvailability(sel);

      optionSets.forEach(function (fs, i) {
        var label = fs.querySelector('[data-mv-selected]');
        if (label) label.textContent = sel[i] || '';
      });
      section.querySelectorAll('[data-mv-id]').forEach(function (inp) { if (v) inp.value = v.id; });

      var pct = savePct(v);
      section.querySelectorAll('[data-mv-price]').forEach(function (el) {
        if (v) el.textContent = v.priceFmt;
        el.classList.toggle('is-sale', pct > 0);
      });
      section.querySelectorAll('[data-mv-compare]').forEach(function (el) {
        el.textContent = pct > 0 ? v.compareFmt : '';
        el.hidden = pct === 0;
      });
      section.querySelectorAll('[data-mv-save]').forEach(function (el) {
        el.textContent = 'Save ' + pct + '%';
        el.hidden = pct === 0;
      });

      if (atc) {
        var available = !!(v && v.available);
        atc.disabled = !available;
        if (available) atc.removeAttribute('data-unavailable'); else atc.setAttribute('data-unavailable', '');
        if (atcLabel) atcLabel.textContent = available ? atc.dataset.label : (v ? 'Sold out' : 'Unavailable');
      }

      updateStock(v);

      if (sticky && v) {
        var img = sticky.querySelector('[data-mv-sticky-img]');
        if (img && v.img) img.src = v.img;
        if (stickySelect) stickySelect.value = String(v.id);
      }

      if (fromUser && v) {
        if (v.mediaId) {
          for (var i = 0; i < slides.length; i++) {
            if (slides[i].dataset.mediaId === String(v.mediaId)) { goTo(i); break; }
          }
        }
        try {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url.toString());
        } catch (e) { /* ignore */ }
      }
    }
    optionSets.forEach(function (fs) {
      fs.addEventListener('change', function () { update(true); });
    });
    update(false);

    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (atc && atc.disabled) return;
        addToCart(form, atc);
      });
    }

    /* Size chart: open Kiwi's chart when the app is on the page, otherwise the page pop-up */
    section.querySelectorAll('[data-mv-dialog-open]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        var kiwi = document.querySelector('.ks-chart-modal-link, .sizing-chart-modal-link');
        if (kiwi) {
          e.preventDefault();
          kiwi.click();
          return;
        }
        var dlg = document.getElementById(btn.dataset.mvDialogOpen);
        if (dlg && typeof dlg.showModal === 'function') {
          e.preventDefault();
          dlg.showModal();
        }
      });
    });
    section.querySelectorAll('dialog').forEach(function (dlg) {
      dlg.addEventListener('click', function (e) {
        if (e.target === dlg || e.target.closest('[data-mv-dialog-close]')) dlg.close();
      });
    });

    /* Sticky bar — shown once the real button has scrolled above the viewport */
    if (sticky && atc) {
      var stickyBtn = sticky.querySelector('[data-mv-sticky-add]');
      var evaluate = function () {
        var show = atc.getBoundingClientRect().bottom < 0;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        if (stickyBtn) stickyBtn.tabIndex = show ? 0 : -1;
        if (stickySelect) stickySelect.tabIndex = show ? 0 : -1;
      };
      window.addEventListener('scroll', evaluate, { passive: true });
      window.addEventListener('resize', evaluate, { passive: true });
      setInterval(evaluate, 500);
      evaluate();

      if (stickySelect) {
        stickySelect.addEventListener('change', function () {
          var chosen = null;
          for (var i = 0; i < variants.length; i++) {
            if (String(variants[i].id) === stickySelect.value) { chosen = variants[i]; break; }
          }
          if (!chosen) return;
          optionSets.forEach(function (fs, idx) {
            fs.querySelectorAll('input').forEach(function (inp) { inp.checked = inp.value === chosen.options[idx]; });
          });
          update(true);
        });
      }
      if (stickyBtn) {
        stickyBtn.addEventListener('click', function () {
          if (atc.disabled) {
            (section.querySelector('.mv-opts') || atc).scrollIntoView({ behavior: 'smooth', block: 'center' });
            return;
          }
          addToCart(form, atc);
        });
      }
    }
  }

  /* ---------- Complete your look ---------- */
  function initLook(scope) {
    scope.querySelectorAll('[data-mv-look-form]').forEach(function (form) {
      if (form.dataset.ready) return;
      form.dataset.ready = '1';
      var select = form.querySelector('[data-mv-look-select]');
      var btn = form.querySelector('[data-mv-look-add]');
      var err = form.querySelector('[data-mv-error]');
      var card = form.closest('[data-mv-look-card]');
      if (select) {
        select.addEventListener('change', function () {
          var opt = select.options[select.selectedIndex];
          var price = card && card.querySelector('[data-mv-look-price]');
          if (price && opt && opt.dataset.price) price.textContent = opt.dataset.price;
          if (err) err.hidden = true;
        });
      }
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (select) {
          if (select.hidden) {
            select.hidden = false;
            select.focus();
            if (typeof select.showPicker === 'function') { try { select.showPicker(); } catch (x) { /* ignore */ } }
            return;
          }
          if (!select.value) {
            if (err) { err.textContent = 'Please choose an option first.'; err.hidden = false; }
            return;
          }
        }
        addToCart(form, btn);
      });
    });
  }

  /* ---------- Reviews: load more ---------- */
  function initReviews(section) {
    if (section.dataset.mvReady) return;
    section.dataset.mvReady = '1';
    var cards = Array.prototype.slice.call(section.querySelectorAll('[data-mv-rev-card]'));
    var shown = parseInt(section.dataset.initial, 10) || 3;
    var step = parseInt(section.dataset.step, 10) || 3;
    var btn = section.querySelector('[data-mv-more]');
    function apply() {
      cards.forEach(function (c, i) { c.hidden = i >= shown; });
      if (btn) btn.hidden = shown >= cards.length;
    }
    if (btn) btn.addEventListener('click', function () { shown += step; apply(); });
    apply();
  }

  /* ---------- You may also like ---------- */
  function initYmal(section) {
    if (section.dataset.mvReady) return;
    section.dataset.mvReady = '1';
    var track = section.querySelector('[data-mv-ymal-grid]');
    if (!track) return;

    function step(dir) {
      var card = track.querySelector('[data-acg-card]');
      var width = card ? card.getBoundingClientRect().width + 16 : track.clientWidth * 0.8;
      track.scrollBy({ left: dir * width, behavior: 'smooth' });
    }
    var prev = section.querySelector('[data-mv-ymal-prev]');
    var next = section.querySelector('[data-mv-ymal-next]');
    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });

    // Swap in Shopify's related-product recommendations for the same gender.
    var url = section.dataset.recsUrl;
    var gender = section.dataset.gender;
    if (!url) return;
    fetch(url)
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var cards = Array.prototype.slice.call(doc.querySelectorAll('[data-mv-ymal-grid] > [data-acg-card]')).filter(function (card) {
          return !gender || card.dataset.gender === gender;
        });
        if (cards.length >= 4) {
          track.innerHTML = '';
          cards.forEach(function (card) { track.appendChild(card); });
          section.classList.remove('mv-ymal--empty');
        }
      })
      .catch(function () { /* keep the category products */ });
  }

  function init(scope) {
    scope = scope || document;
    scope.querySelectorAll('[data-mv]').forEach(initMain);
    scope.querySelectorAll('[data-mv-reviews]').forEach(initReviews);
    scope.querySelectorAll('[data-mv-ymal]').forEach(initYmal);
    initLook(scope);
    initCountdowns(scope);
    initShipBy(scope);
  }

  window.AurevPDP2 = { init: init, addToCart: addToCart };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
